module.exports = __webpack_public_path__ + "img/bol04.6d4c2a0a.jpg";